import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { closeReportToast } from 'redux-api/action/reportToast';
import ReportToast from 'components/billing/reports/report-toast';

function ReduxReportToast() {
  const dispatch = useDispatch();
  const reportToastState = useSelector((state) => state.reportToast) || {
    isVisible: false,
    status: null,
    reportPeriod: '',
    downloadUrl: null,
  };

  const handleClose = useCallback(() => {
    dispatch(closeReportToast());
  }, [dispatch]);

  const handleDownload = useCallback((url) => {
    window.open(url, '_blank');
  }, []);

  return (
    <ReportToast
      isVisible={reportToastState.isVisible}
      status={reportToastState.status}
      reportPeriod={reportToastState.reportPeriod}
      downloadUrl={reportToastState.downloadUrl}
      onClose={handleClose}
      onDownload={handleDownload}
    />
  );
}

export default ReduxReportToast; 